module.exports = __webpack_public_path__ + "img/plane_engine_and_wheel.38a7949c.jpg";